export const SERVICE_GATEWAYS = {
  CUSTOMER_SERVICE: 'customer-service',
  CHAT_CONFIG: 'chat-config',
  CAMPAIGNS: 'campaigns',
  CHAT_ADAPTER: 'chat-adapter',
  ASSETS: 'assets',
  CONTACT_LIST: 'contact-list',
  INTEGRATIONS: 'integrations',
  CHAT_WEBSERVICE: 'chat-webservice',
  CALL_REPORT: 'call-report',
  CALLS: 'calls',
  CASES: 'cases',
  RH: 'rh',
  ACCESS_HUB: 'access-hub',
  NOTIFICATIONS: 'notifications',
} as const;

export type SERVICE_GATEWAYS = (typeof SERVICE_GATEWAYS)[keyof typeof SERVICE_GATEWAYS];
